import  uuid from 'uuidv4';


export const isMobileDevice=()=> {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}

export const isOrientationSupport =()=>{

    if (window.DeviceOrientationEvent) {
       
        return true 
      } else {
        return false  
        
      }

}
export const supportOrientationChannge = (callback)=>{
    // console.log('supportOrientationChannge')
    window.addEventListener("deviceorientation", callback);
}
export const hardReload=(state=true)=>{
  document.location.reload(true)
}

export const isTouchDevice=()=> {
    return (('ontouchstart' in window)
         || (navigator.MaxTouchPoints > 0)
         || (navigator.msMaxTouchPoints > 0));
   }

export const randomColor = ()=>{

    const letters = "0123456789ABCDEF"; 
    let color = '#'; 
    for (let i = 0; i < 6; i++) 
       color += letters[(Math.floor(Math.random() * 16))]; 

    // return '#'+Math.floor(Math.random()*16777215).toString(16)
    return color
}   

export const strTime= (data)=>{
   console.log('strTime')
    var txt=data;
    var re1='(\\d+)';	// Integer Number 1
      var re2='(-)';	// Any Single Character 1
      var re3='(\\d+)';	// Integer Number 2
      var re4='(-)';	// Any Single Character 2
      var re5='(\\d+)';	// Integer Number 3
      var re6='(T)';	// Any Single Word Character (Not Whitespace) 1
      var re7='(\\d+)';	// Integer Number 4
      var re8='(:)';	// Any Single Character 3
      var re9='(\\d+)';	// Integer Number 5
      var re10='(:)';	// Any Single Character 4
      var re11='(\\d+)';	// Integer Number 6
      var re12='(\\.)';	// Any Single Character 5
      var re13='(\\d+)';	// Integer Number 7
      var re14='(Z)';	// Any Single Word Character (Not Whitespace) 2

      var p = new RegExp(re1+re2+re3+re4+re5+re6+re7+re8+re9+re10+re11+re12+re13+re14,["i"]);
      var m = p.exec(txt);
      if (m != null)
      {
          var int1=m[1];
          var c1=m[2];
          var int2=m[3];
          var c2=m[4];
          var int3=m[5];
          var w1=m[6];
          var int4=m[7];
          var c3=m[8];
          var int5=m[9];
          var c4=m[10];
          var int6=m[11];
          var c5=m[12];
          var int7=m[13];
          var w2=m[14];
          console.log(int1,int2,int3,int4,int5,int6,int7)
        }
        let Tobj = {
                year: int1,
                month:int2,
                day:int3,
                hour:int4,
                minute:int5,
                sec:int6,
                msec:int7
        }
        return Tobj
}
export const getUTCMiliSec= ()=>{

    var now = new Date;
    var utc_timestamp = Date.UTC(now.getUTCFullYear(),now.getUTCMonth(), now.getUTCDate() , 
      now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
    return utc_timestamp;
}

export const lngFix =(x)=>{

  let n = (x + 180) % 360;
  if (n < 0) {
    n += 360;
  }
  return n - 180;

}

export const pad =(str ,size) =>{
  var s = String(str);
  while (s.length < (size || 2)) {s = "0" + s;}
  return s;
}